export const PORTAL_URL = "https://distro.doblerrecords.com/";

export const NAV_ITEMS = [
  { href: "#inicio", key: "home" },
  { href: "#servicios", key: "services" },
  { href: "#proceso", key: "howItWorks" },
  { href: "#plataformas", key: "platforms" },
  { href: "#regalias", key: "royalties" },
  { href: "#faq", key: "faq" },
  { href: "#contacto", key: "contact" },
];

export const PLATFORMS = [
  { name: "Spotify", icon: "spotify" },
  { name: "Apple Music & iTunes", icon: "applemusic" },
  { name: "YouTube Music", icon: "youtubemusic" },
  { name: "Amazon Music", icon: "generic" },
  { name: "Deezer", icon: "deezer" },
  { name: "Tidal", icon: "tidal" },
  { name: "TikTok", icon: "tiktok" },
  { name: "Facebook", icon: "facebook" },
  { name: "Instagram", icon: "instagram" },
  { name: "Pandora", icon: "pandora" },
  { name: "SoundCloud", icon: "soundcloud" },
  { name: "Boomplay", icon: "generic" },
  { name: "XITE", icon: "generic" },
  { name: "Anghami", icon: "generic" },
  { name: "iHeartRadio", icon: "iheartradio" },
  { name: "Napster", icon: "napster" },
  { name: "Claro Música", icon: "generic" },
  { name: "Qobuz", icon: "generic" },
  { name: "Shazam", icon: "shazam" },
  { name: "VEVO", icon: "generic" },
  { name: "7Digital", icon: "generic" },
  { name: "ACRCloud", icon: "generic" },
  { name: "AMI Entertainment", icon: "generic" },
  { name: "Audible Magic", icon: "generic" },
  { name: "AudioMack", icon: "audiomack" },
  { name: "AWA", icon: "generic" },
  { name: "Beatport", icon: "beatport" },
  { name: "Beatsource", icon: "generic" },
  { name: "BMAT", icon: "generic" },
  { name: "BPM Supreme", icon: "generic" },
  { name: "ClicknClear", icon: "generic" },
  { name: "FLO", icon: "generic" },
  { name: "Gaana", icon: "generic" },
  { name: "Hungama", icon: "generic" },
  { name: "JioSaavn", icon: "generic" },
  { name: "JOOX", icon: "generic" },
  { name: "RX Music", icon: "generic" },
  { name: "KkBox", icon: "generic" },
  { name: "Kuack Media Group", icon: "generic" },
  { name: "Kuaishou", icon: "kuaishou" },
  { name: "Meta", icon: "meta" },
  { name: "Mixcloud", icon: "mixcloud" },
  { name: "Mixlo", icon: "generic" },
  { name: "Mixupload", icon: "generic" },
  { name: "Muso.AI", icon: "generic" },
  { name: "NetEase Cloud Music", icon: "generic" },
  { name: "Nightlife Music", icon: "generic" },
  { name: "Nuuday", icon: "generic" },
  { name: "Peloton", icon: "peloton" },
  { name: "PEX", icon: "generic" },
  { name: "Pretzel", icon: "generic" },
  { name: "RightsUp", icon: "generic" },
  { name: "Rythm.FM", icon: "generic" },
  { name: "SoundExchange", icon: "generic" },
  { name: "Supernatural", icon: "generic" },
  { name: "Tencent Music", icon: "generic" },
  { name: "Douyin", icon: "generic" },
  { name: "CapCut", icon: "generic" },
  { name: "TouchTunes", icon: "generic" },
  { name: "Trebel", icon: "generic" },
  { name: "Alibaba", icon: "alibaba" },
  { name: "Vibe-Stream.tv", icon: "generic" },
  { name: "Volumo", icon: "generic" },
  { name: "YouTube Content ID", icon: "youtube" },
  { name: "Gracenote", icon: "generic" },
  { name: "Mood Media", icon: "generic" },
  { name: "Slacker", icon: "generic" },
  { name: "Tuned Global", icon: "generic" },
  { name: "Rumble", icon: "rumble" },
  { name: "Lola Music", icon: "generic" },
  { name: "Styngr", icon: "generic" },
  { name: "JPay", icon: "generic" },
  { name: "iTunes", icon: "generic" },
  { name: "WeSing", icon: "generic" },
  { name: "Rdio", icon: "generic" },
  { name: "QQ Music", icon: "generic" },
  { name: "ViaPath Technologies", icon: "generic" },
  { name: "Saavn", icon: "generic" },
  { name: "Ayoba", icon: "generic" },
  { name: "Soundmouse", icon: "generic" },
  { name: "Melon", icon: "generic" },
  { name: "Jaxsta", icon: "generic" },
  { name: "D'Music", icon: "generic" },
  { name: "Taobao", icon: "generic" },
  { name: "Claro Music", icon: "generic" },
  { name: "Meta Music", icon: "generic" },
  { name: "Musixmatch", icon: "generic" },
  { name: "Music Island", icon: "generic" },
  { name: "Bugs Music", icon: "generic" },
  { name: "Mnet", icon: "generic" },
  { name: "Kugou", icon: "generic" },
  { name: "Snapchat", icon: "snapchat" },
  { name: "Movistar Music", icon: "generic" },
  { name: "Broadtime", icon: "generic" },
  { name: "Pandora Music", icon: "generic" },
  { name: "Genie Music", icon: "generic" },
  { name: "Naver Music", icon: "generic" },
  { name: "Amazon", icon: "generic" },
  { name: "Stationhead", icon: "generic" },
  { name: "Canva", icon: "generic" },
  { name: "Adaptr", icon: "generic" },
  { name: "Boomplay Music", icon: "generic" },
  { name: "Twitch Soundtrack", icon: "twitch" },
  { name: "Kuwo", icon: "generic" },
  { name: "KUACK", icon: "generic" },
  { name: "Soundtrack Your Brand", icon: "generic" },
  { name: "Anghami Music", icon: "generic" },
  { name: "Keefe", icon: "generic" },
  { name: "Resso", icon: "generic" },
  { name: "ROXi", icon: "generic" },
  { name: "Audible Magic - Rights360", icon: "generic" },
  { name: "AWA Music", icon: "generic" },
  { name: "LyricFind", icon: "generic" },
  { name: "Apple Music", icon: "generic" },
  { name: "Vodaphone Play", icon: "generic" },
  { name: "Tracxsource", icon: "generic" },
  { name: "Bitel", icon: "generic" },
  { name: "Airtel tv", icon: "generic" },
  { name: "UnitedMasters", icon: "generic" },
  { name: "Line Music", icon: "generic" },
  { name: "YouTube Premium", icon: "generic" },
  { name: "Tik Tok Music", icon: "generic" },
  { name: "Amazon Prime", icon: "generic" },
  { name: "WhatsApp Music", icon: "generic" },
  { name: "Lickd", icon: "generic" },
  { name: "Flo Music", icon: "generic" },
  { name: "Slacker Radio", icon: "generic" },
  { name: "Songclip LLC", icon: "generic" },
  { name: "Yandex", icon: "generic" },
  { name: "Pinterest", icon: "pinterest" },
  { name: "Bmat Music Innovators", icon: "generic" },
  { name: "TuneIn", icon: "generic" },
  { name: "Lissen", icon: "generic" },
  { name: "Massive Music", icon: "generic" },
  { name: "Fan Label", icon: "generic" },
  { name: "Soundhound", icon: "generic" },
  { name: "Xiaomi Music", icon: "generic" },
  { name: "Samsung Music", icon: "generic" },
  { name: "Singtel", icon: "generic" },
  { name: "Starhub", icon: "generic" },
  { name: "B612", icon: "generic" },
  { name: "Bilibili", icon: "generic" },
  { name: "DiGi (Audio)", icon: "generic" },
  { name: "Global Radio", icon: "generic" },
  { name: "MQA (Audio)", icon: "generic" },
  { name: "Psonar", icon: "generic" },
  { name: "Taiwan Mobile", icon: "generic" },
  { name: "SparkAR", icon: "generic" },
  { name: "Threads", icon: "threads" },
  { name: "Sirius XM", icon: "generic" },
  { name: "Audacy", icon: "generic" },
  { name: "Songtradr", icon: "generic" },
  { name: "AGEDI", icon: "generic" },
  { name: "Audible Magic - Fulfillment360", icon: "generic" },
  { name: "Ambients App", icon: "generic" },
  { name: "DISCO", icon: "generic" },
  { name: "Curve", icon: "generic" },
  { name: "PEX Attribution Engine", icon: "generic" },
  { name: "iHeart", icon: "generic" },
  { name: "IMI Mobile", icon: "generic" },
  { name: "Kanjian", icon: "generic" },
  { name: "KDigital Media", icon: "generic" },
  { name: "Medianet", icon: "generic" },
  { name: "MoodAgent", icon: "generic" },
  { name: "MusicToday", icon: "generic" },
  { name: "Play Network", icon: "generic" },
  { name: "Pretzel Rocks", icon: "generic" },
  { name: "Rebelation", icon: "generic" },
  { name: "Rockbot", icon: "generic" },
  { name: "Rhapsody", icon: "generic" },
  { name: "Rakuten", icon: "generic" },
  { name: "Rakuten Music", icon: "generic" },
  { name: "Soundtrack by Twitch", icon: "twitch" },
  { name: "Twitch", icon: "twitch" },
  { name: "Tencent", icon: "generic" },
  { name: "Tesla Music", icon: "generic" },
  { name: "Grandpad", icon: "generic" },
  { name: "Traxsource", icon: "generic" },
  { name: "Triller", icon: "generic" },
  { name: "Trackdrip", icon: "generic" },
  { name: "United Media Agency (UMA)", icon: "generic" },
  { name: "VL Groupe", icon: "generic" },
  { name: "Music Clone Digital", icon: "generic" },
  { name: "Music Reports", icon: "generic" },
  { name: "Mythical Games", icon: "generic" },
  { name: "Keefe Group", icon: "generic" },
  { name: "ViaPath", icon: "generic" },
  { name: "Turnkey Corrections", icon: "generic" },
  { name: "Artie", icon: "generic" },
  { name: "Oga Dance (MoveWorld)", icon: "generic" },
  { name: "DanceFight", icon: "generic" },
  { name: "Hyundaicard Music", icon: "generic" },
  { name: "Melon Kt", icon: "generic" },
  { name: "Olleh+", icon: "generic" },
  { name: "Genie", icon: "generic" },
  { name: "Soribada", icon: "generic" },
  { name: "Bugs!", icon: "generic" },
  { name: "Dalkom", icon: "generic" },
  { name: "Cyworld", icon: "generic" },
  { name: "Daum", icon: "generic" },
  { name: "Acer", icon: "generic" },
  { name: "Audiojungle", icon: "generic" },
  { name: "China Unicom", icon: "generic" },
  { name: "Wo Music", icon: "generic" },
  { name: "Bleep", icon: "generic" },
  { name: "CCA", icon: "generic" },
  { name: "CDON", icon: "generic" },
  { name: "Celcom", icon: "generic" },
  { name: "Changba", icon: "generic" },
  { name: "Chunghwa Mobile", icon: "generic" },
  { name: "CTS Eventim AG", icon: "generic" },
  { name: "Dance All Day", icon: "generic" },
  { name: "DiGi", icon: "generic" },
  { name: "Digitally Imported", icon: "generic" },
  { name: "Douban Music", icon: "generic" },
  { name: "Dragonfly FM", icon: "generic" },
  { name: "Echo", icon: "generic" },
  { name: "Findspire", icon: "generic" },
  { name: "FNAC", icon: "generic" },
  { name: "Friday Music (Omusic)", icon: "generic" },
  { name: "FUHU", icon: "generic" },
  { name: "Gismart", icon: "generic" },
  { name: "Hardstyle.com", icon: "generic" },
  { name: "Himalayan FM", icon: "generic" },
  { name: "HMV", icon: "generic" },
  { name: "hmv PLAY (Soliton)", icon: "generic" },
  { name: "HTC One", icon: "generic" },
  { name: "Huawei Music", icon: "generic" },
  { name: "Huawei Music - Hi res", icon: "generic" },
  { name: "Huawei South Africa", icon: "generic" },
  { name: "Huawei Middle East", icon: "generic" },
  { name: "iam+", icon: "generic" },
  { name: "Dial", icon: "generic" },
  { name: "iFeng", icon: "generic" },
  { name: "Jeou Tai", icon: "generic" },
  { name: "Jinli Music", icon: "generic" },
  { name: "Kanjian Music", icon: "generic" },
  { name: "Koala FM", icon: "generic" },
  { name: "Kobo", icon: "generic" },
  { name: "Kuyin Ringtone", icon: "generic" },
  { name: "La Musica", icon: "generic" },
  { name: "Last FM", icon: "generic" },
  { name: "Lenovo Music", icon: "generic" },
  { name: "Lenovo Sound", icon: "generic" },
  { name: "Lequ Music", icon: "generic" },
  { name: "Lizhi FM", icon: "generic" },
  { name: "Love Music (China Telecom)", icon: "generic" },
  { name: "Mach by Mariposa", icon: "generic" },
  { name: "Maxis", icon: "generic" },
  { name: "Me2u Music", icon: "generic" },
  { name: "Media Markt", icon: "generic" },
  { name: "Medion", icon: "generic" },
  { name: "Mi Tracks", icon: "generic" },
  { name: "Migu Music (China Mobile)", icon: "generic" },
  { name: "Mixpixie", icon: "generic" },
  { name: "Mixup Digital", icon: "generic" },
  { name: "Moi Mir", icon: "generic" },
  { name: "MOOV", icon: "generic" },
  { name: "MQA", icon: "generic" },
  { name: "MusicQubed", icon: "generic" },
  { name: "MyMusic", icon: "generic" },
  { name: "Onkyo", icon: "generic" },
  { name: "Open Live", icon: "generic" },
  { name: "Overmax", icon: "generic" },
  { name: "Pledge", icon: "generic" },
  { name: "Pono", icon: "generic" },
  { name: "Prodigium", icon: "generic" },
  { name: "Infogo", icon: "generic" },
  { name: "Pubbles", icon: "generic" },
  { name: "Pulselocker", icon: "generic" },
  { name: "Raku", icon: "generic" },
  { name: "ROK mobile", icon: "generic" },
  { name: "Sainsburys", icon: "generic" },
  { name: "Saturn", icon: "generic" },
  { name: "Stellar", icon: "generic" },
  { name: "TDCT Star", icon: "generic" },
  { name: "Qianqian Music", icon: "generic" },
  { name: "TDC/TDC Mobile", icon: "generic" },
  { name: "Technics Tracks", icon: "generic" },
  { name: "The Overflow", icon: "generic" },
  { name: "TingTing FM", icon: "generic" },
  { name: "Triplay", icon: "generic" },
  { name: "U-Mobile", icon: "generic" },
  { name: "Vibe", icon: "generic" },
  { name: "VUE", icon: "generic" },
  { name: "Walkgame", icon: "generic" },
  { name: "Wasu TV", icon: "generic" },
  { name: "Weibo Music", icon: "generic" },
  { name: "Weltbild DE", icon: "generic" },
  { name: "Xiutang", icon: "generic" },
  { name: "Yiqixiu", icon: "generic" },
  { name: "friDay", icon: "generic" },
  { name: "Alibaba Group", icon: "generic" },
  { name: "Migu Music", icon: "generic" },
  { name: "Netease Music", icon: "generic" },
  { name: "Love Music", icon: "generic" },
  { name: "China Telecom", icon: "generic" },
  { name: "HUAWEI Hi-Res", icon: "generic" },
  { name: "24-7 Entertainment", icon: "generic" },
  { name: "Huawei Global Radio", icon: "generic" },
  { name: "Orange France", icon: "generic" },
  { name: "Tigo", icon: "generic" },
  { name: "Deutsche Telekom Austria and Netherlands", icon: "generic" },
  { name: "Swisscom", icon: "generic" },
  { name: "Fastweb", icon: "generic" },
  { name: "Belgacom", icon: "generic" },
  { name: "Tango", icon: "generic" },
  { name: "Vibo Telecom", icon: "generic" },
  { name: "Line Music (JP)", icon: "generic" },
  { name: "TIM Music", icon: "generic" },
  { name: "Kuack Media", icon: "generic" },
  { name: "Naver Vibe", icon: "generic" },
  { name: "Sunrise", icon: "generic" },
  { name: "Rhino", icon: "generic" },
  { name: "mobilcom-debitel", icon: "generic" },
  { name: "MePlaylist", icon: "generic" },
  { name: "CCI Distribution", icon: "generic" },
  { name: "Tonspion", icon: "generic" },
  { name: "Sonos", icon: "generic" },
  { name: "TELE2", icon: "generic" },
  { name: "Vodafone", icon: "generic" },
  { name: "3.DK", icon: "generic" },
  { name: "Bose", icon: "generic" },
  { name: "In8 Mobile", icon: "generic" },
  { name: "GHH Commerce", icon: "generic" },
  { name: "Music Worx", icon: "generic" },
  { name: "Astro", icon: "generic" },
  { name: "T-Mobile", icon: "generic" },
  { name: "Spanish Broadcasting System", icon: "generic" },
  { name: "Turntable.fm", icon: "generic" },
  { name: "Tradebit", icon: "generic" },
  { name: "ShopTo", icon: "generic" },
  { name: "RBS", icon: "generic" },
  { name: "NatWest", icon: "generic" },
  { name: "Gravity Mobile", icon: "generic" },
  { name: "doubleTwist", icon: "generic" },
  { name: "Clip Interactive", icon: "generic" },
  { name: "Pure Music", icon: "generic" },
  { name: "Cyberlink", icon: "generic" },
  { name: "Huawei Ringtone", icon: "generic" },
  { name: "VIVO Hi-Res", icon: "generic" },
  { name: "Yunting", icon: "generic" },
  { name: "Yesoul", icon: "generic" },
  { name: "CIGKids+", icon: "generic" },
  { name: "CoSleep&Heart", icon: "generic" },
  { name: "Wondershare", icon: "generic" },
  { name: "Tingxi", icon: "generic" },
  { name: "VCG", icon: "generic" },
  { name: "58pic", icon: "generic" },
  { name: "Qianku", icon: "generic" },
  { name: "Daily Yoga", icon: "generic" },
  { name: "Kelakela", icon: "generic" },
  { name: "Jinshan", icon: "generic" },
  { name: "Gaoding", icon: "generic" },
  { name: "DOOLUU", icon: "generic" },
  { name: "Duitang", icon: "generic" },
  { name: "Bijian", icon: "generic" },
  { name: "Baotu", icon: "generic" },
  { name: "BabyTree", icon: "generic" },
  { name: "epub360", icon: "generic" },
  { name: "P.R.O. Agency", icon: "generic" },
  { name: "Litup", icon: "generic" },
  { name: "Conservar", icon: "generic" },
  { name: "Xiaohongshu", icon: "generic" },
  { name: "Audio Stock", icon: "generic" },
  { name: "NEC", icon: "generic" },
  { name: "Momople", icon: "generic" },
  { name: "Tencent Video", icon: "generic" },
  { name: "Sohu Video", icon: "generic" },
  { name: "Sina Video", icon: "generic" },
  { name: "MGTV", icon: "generic" },
  { name: "Xplore Music Stores", icon: "generic" },
  { name: "PPTV", icon: "generic" },
  { name: "Youku & Tudou", icon: "generic" },
  { name: "iQiyi & PPS", icon: "generic" },
  { name: "Rabbit", icon: "generic" },
  { name: "China Airlines", icon: "generic" },
  { name: "Jetstar", icon: "generic" },
  { name: "Nile Air", icon: "generic" },
  { name: "Qantas", icon: "generic" },
  { name: "UC", icon: "generic" },
  { name: "Viper HIFI", icon: "generic" },
  { name: "Rainbow Music", icon: "generic" },
  { name: "Fliggy", icon: "generic" },
  { name: "Hema", icon: "generic" },
  { name: "Huoshan", icon: "generic" },
  { name: "Viamaker", icon: "generic" },
  { name: "Juhuasuan", icon: "generic" },
  { name: "Ku FM", icon: "generic" },
  { name: "Kuwo Boom", icon: "generic" },
  { name: "Kuwo Juxing", icon: "generic" },
  { name: "Kuwo KTV", icon: "generic" },
  { name: "Kuwo Video", icon: "generic" },
  { name: "Kuwo Tingshu", icon: "generic" },
  { name: "QQ FM", icon: "generic" },
  { name: "Qingting", icon: "generic" },
  { name: "Virgin Australia", icon: "generic" },
  { name: "Kugou Sing", icon: "generic" },
  { name: "Kugou KTV", icon: "generic" },
  { name: "Kugou Ringtone", icon: "generic" },
  { name: "Kugou Live", icon: "generic" },
  { name: "Top Music", icon: "generic" },
  { name: "Meitu", icon: "generic" },
  { name: "Tmall", icon: "generic" },
  { name: "Weishi", icon: "generic" },
  { name: "WeChat", icon: "wechat" },
  { name: "Xigua Video", icon: "generic" },
  { name: "Intime", icon: "generic" },
  { name: "Alipay", icon: "alipay" },
  { name: "AirAsia", icon: "generic" },
  { name: "AirAsiaX", icon: "generic" },
  { name: "Air Vanuatu", icon: "generic" },
  { name: "Alibaba Cloud Computing", icon: "generic" },
  { name: "SunExpress", icon: "generic" },
  { name: "Vistopia", icon: "generic" },
  { name: "Agora", icon: "generic" },
  { name: "Xinhua Zhiyun Technology", icon: "generic" },
  { name: "Xinpianchang", icon: "generic" },
  { name: "Perfect World", icon: "generic" },
  { name: "iSheji", icon: "generic" },
  { name: "Pikbest", icon: "generic" },
  { name: "HelloRF", icon: "generic" },
  { name: "Bandcamp", icon: "bandcamp" },
  { name: "Onmobile US", icon: "generic" },
  { name: "iMusica", icon: "generic" },
  { name: "VKontakte", icon: "vk" },
  { name: "Qishui Music", icon: "generic" },
  { name: "Wasu", icon: "generic" },
  { name: "Meishe", icon: "generic" },
  { name: "Videoshow", icon: "generic" },
  { name: "Thai Airways", icon: "generic" },
  { name: "Philippine Airlines", icon: "generic" },
  { name: "GMF AeroAsia", icon: "generic" },
  { name: "Kwai", icon: "generic" },
  { name: "Muserk", icon: "generic" },
  { name: "Snack Video", icon: "generic" },
  { name: "fizy", icon: "generic" },
  { name: "Barstool Sports", icon: "generic" },
  { name: "Delta", icon: "generic" },
  { name: "Pizza Hut", icon: "generic" },
  { name: "Lululemon", icon: "generic" },
  { name: "Bubuka", icon: "generic" },
  { name: "Beeline Music", icon: "generic" },
  { name: "Coda Music", icon: "generic" },
  { name: "Soda Music", icon: "generic" },
  { name: "Roblox", icon: "roblox" },
];

export const SERVICE_LAYOUT = [
  { id: "distribucion", span: "md:col-span-2 md:row-span-2", image: "https://static.prod-images.emergentagent.com/jobs/4bcff601-ff05-4713-b2a7-2b2784a9df18/images/eb4304cad7e8b7923a354ede58ef2a2b56cbef006e2ec775d95afbee2f12eb77.jpeg" },
  { id: "vevo", span: "md:col-span-2 md:row-span-1" },
  { id: "catalogo", span: "md:col-span-1 md:row-span-1" },
  { id: "revision", span: "md:col-span-1 md:row-span-1" },
  { id: "metadata", span: "md:col-span-1 md:row-span-1" },
  { id: "upc-isrc", span: "md:col-span-1 md:row-span-1" },
  { id: "regalias-tiempo-real", span: "md:col-span-2 md:row-span-1", image: "https://static.prod-images.emergentagent.com/jobs/4bcff601-ff05-4713-b2a7-2b2784a9df18/images/76770b383f3e6d16f7326c1e2799fe6d9dfd7c6903ec0fafb7902a00c46848f4.jpeg" },
  { id: "splits", span: "md:col-span-1 md:row-span-1" },
  { id: "statements", span: "md:col-span-1 md:row-span-1" },
  { id: "presave", span: "md:col-span-1 md:row-span-1" },
  { id: "soporte", span: "md:col-span-1 md:row-span-1" },
];

export const CATALOG_STATUS_COLORS = ["bg-emerald-400", "bg-sky-400", "bg-amber-400", "bg-neutral-400"];
